import { useState } from 'react';
import './Templates.scss';

const templates = [
  {
    id: 1,
    title: 'Multi-Page Shop',
    image: '/assets/templates/shop/picture.webp',
    description: 'A Shop System with a set of Panels featuring pre-made categories. Clicking an item will open a GUI asking to either buy/sell the item at a custom quantity.',
    dependencies: [
      'PlaceholderAPI Math Extension',
      'PlaceholderAPI Player Extension',
      'Vault Plugin',
      'Economy Plugin',
    ],
    commands: [
      '/shop',
      '/market',
    ],
    link: '/assets/templates/shop/shop.zip',
  },
  {
    id: 2,
    title: 'Player Rankup',
    image: '/assets/templates/rankup/picture.webp',
    description: 'A Rankup Panel that has a list of nine ranks for players to get promoted through. A LuckPerms track will need to be created to promote players.',
    dependencies: [
      'Luckperms Rank Track',
      'PlaceholderAPI Player Extension',
      'PlaceholderAPI Statistic Extension',
      'Vault Plugin',
      'Economy Plugin',
    ],
    commands: [
      '/rankup',
    ],
    link: '/assets/templates/rankup/rankup.yml',
  },
  {
    id: 3,
    title: 'Daily Reward',
    image: '/assets/templates/daily_reward/picture.webp',
    description: 'A Daily Reward Panel that allows players to claim rewards every 24 hours, with better rewards based on their rank.',
    dependencies: [
      'PlaceholderAPI Player Extension',
      'PlaceholderAPI LuckPerms Extension',
      'Vault Plugin',
      'Economy Plugin',
    ],
    commands: [
      '/daily',
      '/dailyreward',
      '/dailyrewards',
      '/rewards'
    ],
    link: '/assets/templates/daily_reward/daily_reward.yml',
  },
  {
    id: 4,
    title: 'Mystery Crate',
    image: '/assets/templates/mystery_crate/picture.webp',
    description: 'A Mystery Crate Panel that allows players to spin for a chance to win various rewards.',
    dependencies: [
      'PlaceholderAPI Plugin',
    ],
    commands: [
      '/crate',
      '/crates',
      '/mysterycrate'
    ],
    link: '/assets/templates/mystery_crate/mystery_crate.zip',
  },
];

const Templates = () => {
  const [activeTemplate, setActiveTemplate] = useState(null);

  const openModal = (template) => setActiveTemplate(template);
  const closeModal = () => setActiveTemplate(null);

  return (
    <div className="templatesContainer">
      <header className="templatesHeader">
        <h1>Templates</h1>
        <span className="templatesHeaderTag">Official Panels</span>
      </header>

      <div className="templatesSubheader">
        <p>Some configurations may be bundled in a zip file. Unzip into your panels folder.</p>
        <p>Have a high-quality template to share? Submit it on Discord for consideration in the official library.</p>
      </div>

      <div className="tileGrid">
        {templates.map((template) => (
          <div className="templateTile" key={template.id}>
            <div className="tileImageWrap">
              <img
                src={template.image}
                alt={template.title}
                className="tileImage"
                onClick={() => openModal(template)}
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  e.currentTarget.parentElement.classList.add('tileImagePlaceholder');
                }}
              />
            </div>
            <div className="tileFooter">
              <span className="tileTitle">{template.title}</span>
              <button
                className="tileButton"
                onClick={() => openModal(template)}
              >
                Details
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {activeTemplate && (
        <div className="modalOverlay" onClick={closeModal}>
          <div className="modalPanel" onClick={(e) => e.stopPropagation()}>
            <button className="modalClose" onClick={closeModal} aria-label="Close">✕</button>

            <h2 className="modalTitle">{activeTemplate.title}</h2>

            <p className="modalDescription">{activeTemplate.description}</p>

            <div className="modalSection">
              <h3 className="modalSectionHeading">Dependencies</h3>
              <ul className="modalList">
                {activeTemplate.dependencies.map((dep, i) => (
                  <li key={i}>{dep}</li>
                ))}
              </ul>
            </div>

            <div className="modalSection">
              <h3 className="modalSectionHeading">Commands</h3>
              <ul className="commandList">
                {activeTemplate.commands.map((cmd, i) => (
                  <li key={i}>
                    <code>{cmd}</code>
                  </li>
                ))}
              </ul>
            </div>

            <a
              className="modalDownloadButton"
              href={activeTemplate.link}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Templates;
